export default function DispatchFocusPanel({ items, onOpen, onDragStart }) {
  const urgent = items
    .filter((item) => item.priorityKey === "spoed" || item.priorityKey === "hoog")
    .slice(0, 6);
  const project = items.filter((item) => item.workTypeLabel === "Project").slice(0, 6);
  const service = items.filter((item) => item.workTypeLabel !== "Project").slice(0, 6);

  const sections = [
    { key: "urgent", label: "Direct plannen", items: urgent },
    { key: "project", label: "Projectwerk", items: project },
    { key: "service", label: "Service en storing", items: service },
  ];

  return (
    <section className="rounded-[26px] border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-4">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
          Werkvoorraadfocus
        </p>
        <h2 className="mt-1 text-lg font-semibold text-slate-950">Werkvoorraad en intake</h2>
        <p className="mt-2 text-sm text-slate-500">
          Gebruik de werkvoorraad links om te prioriteren en open werk klaar te zetten voor de dagplanning.
        </p>
      </div>

      <div className="grid gap-4 xl:grid-cols-3">
        {sections.map((section) => (
          <div key={section.key} className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="text-sm font-semibold text-slate-900">{section.label}</h3>
              <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-slate-700">
                {section.items.length}
              </span>
            </div>

            <div className="space-y-3">
              {section.items.length === 0 ? (
                <div className="rounded-2xl border border-dashed border-slate-200 bg-white px-3 py-8 text-center text-sm text-slate-500">
                  Geen werk in deze sectie.
                </div>
              ) : (
                section.items.map((item) => (
                  <button
                    key={`${section.key}-${item.id}`}
                    type="button"
                    draggable
                    onDragStart={(event) => onDragStart(event, item, "dispatch")}
                    onClick={() => onOpen(item)}
                    className="w-full rounded-2xl border border-slate-200 bg-white p-3 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
                  >
                    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
                      {item.werkbonNummer || "Werkbon"}
                    </p>
                    <div className="mt-1 flex items-start justify-between gap-2">
                      <p className="text-sm font-semibold text-slate-950">{item.title}</p>
                      <span className={`shrink-0 rounded-full px-2 py-1 text-[11px] font-semibold ${item.statusBadgeClass}`}>
                        {item.statusLabel}
                      </span>
                    </div>
                    <p className="mt-1 text-xs text-slate-600">{item.clientName}</p>
                    <p className="mt-1 text-xs text-slate-500">{item.assignedLabel}</p>
                  </button>
                ))
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
